<template>
  <select
    class="dropdown w-100 bg-white overflow-hidden mb-1"
    :value="value"
    @change="$emit('change', $event.target.value)"
  >
    <option v-for="option in options" :key="option.value" :value="option.value">{{ option.text }}</option>
  </select>
</template>

<script>
export default {
  props: {
    value: null,
    options: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown {
  height: 32px;
  object-fit: contain;
  border-radius: 2px;
  border: solid 1px #ddd;
  cursor: pointer;
}
</style>
